export default "__VITE_ASSET__2bmJLsG4__"